import React, { useState, useEffect, useRef } from "react";
import Swiper from "react-id-swiper";
import { Spinner } from "react-bootstrap";
import {
  getWorkshopsAddonByVariant,
  getWorkshopsJourneyVariant,
  getWorkshopsProductCategory,
} from "../../../redux/actions/apiActions";
import {
  addToCart,
  setCartJobItems,
  setCartStage,
  setCartWorkshop,
} from "../../../redux/actions/cartAction";
import { connect } from "react-redux";
import { GetInfo } from "lib/Location";
import { isMobile } from "react-device-detect";
import WorkshopStars from "components/common/WorkshopStars";
import { workshopSelection } from "actions/Cart";
import MapComponent from "components/common/map";
import Slider from "react-slick";

const Map = ({
  id,
  getCoordinates,
  data,
  getWorkshopsProductCategory,
  getWorkshopsJourneyVariant,
  globalData,
  getWorkshopsAddonByVariant,
  setShow,
  setCartStage,
  setCartWorkshop,
  cart,
  setCartJobItems,
}) => {
  const [loaded, setLoaded] = useState(false);
  const [lat, setLat] = useState(25.1287263);
  const [long, setLong] = useState(55.3698033);
  const [zoom, setZoom] = useState(10);
  const [sLoaded, setSLoaded] = useState(false);
  const [swiperr, setSwiper] = useState(null);
  const [activeWorkshop, setActiveWorkshop] = useState({});
  const [selected, setSelected] = useState(0);
  const [selectedWorkshop, setSelectedWorkshop] = useState([]);
  const [showpopup, setShowPopup] = useState(false);
  const [isSubmitting, setIsSubmitting] = useState(false);
  const { jobItems, products } = cart;
  const PopupRef = useRef();

  const handleOutsideClick = (event) => {
    if (PopupRef.current && !PopupRef.current.contains(event.target)) {
      setShowPopup(false);
    }
  };
  useEffect(() => {
    if (showpopup) {
      document.addEventListener("mousedown", handleOutsideClick);
    }
    return () => {
      document.removeEventListener("click", handleOutsideClick);
    };
  }, [showpopup]);
  useEffect(() => {
    const hasLocationPermission = localStorage.getItem("hasLocationPermission");
    if (hasLocationPermission != "granted") getCurrentLocation();
  }, []);
  useEffect(() => {
    if (cart?.workshop?.Id) {
      const workahop = data.workshopFilterMap.filter(
        (data) => data.Id == cart.workshop.Id
      );
      setSelectedWorkshop(workahop);
    }
  }, [cart?.workshop]);

  const getCurrentLocation = () => {
    locateCurrentPosition()
      .then((position) => {
        const lat = Number(position.coords.latitude);
        const lang = Number(position.coords.longitude);
        const size = 10;
        getCoordinates(lat, lang, size);
        setLat(lat);
        setLong(lang);
        setZoom(12);
        setLoaded(true);
        setSLoaded(true);
      })
      .catch((e) => {
        GetInfo(getinfoCallback, getinfoErrorCallback);
      });
  };

  const locateCurrentPosition = () =>
    new Promise((resolve, reject) => {
      navigator.geolocation.getCurrentPosition(
        (position) => {
          resolve(position);
        },
        (error) => {
          console.log(error.message);
          reject(error);
        },
        {
          enableHighAccuracy: true,
          timeout: 10000,
          maximumAge: 1000,
        }
      );
    });

  const getinfoCallback = async (lat, lng) => {
    setLat(Number(lat));
    setLong(Number(lng));
    const size = 10;
    getCoordinates(lat, lng, size);
    setZoom(12);
    setLoaded(true);
    setSLoaded(true);
  };

  const getinfoErrorCallback = (lat, lng) => {
    setLoaded(false);
  };

  const selectWorkshop = async (e) => {
    setIsSubmitting(true);
    if (products.length == 0) {
      setShow(false);
      setCartWorkshop(e);
      let vId = JSON.parse(localStorage.getItem("product-id"));
      let mId = globalData.carData?.modelId;
      getWorkshopsAddonByVariant(e.Id, vId);
      getWorkshopsJourneyVariant(e.Id, id, mId);

      getWorkshopsProductCategory(e.Id, mId);
      setCartStage(3);
      setIsSubmitting(false);
      return;
    }
    let variant = products[0];
    try {
      const res = await workshopSelection(
        e?.Id,
        variant.Id,
        globalData.carData?.modelId,
        null
      );
      if (res.err) {
        showLoader(false);
        setIsSubmitting(false);
        return;
      }
      setShow(false);
      setCartWorkshop(e);
      setCartJobItems([...jobItems, res.Data[0]]);
      let vId = JSON.parse(localStorage.getItem("product-id"));
      let mId = globalData.carData?.modelId;
      getWorkshopsAddonByVariant(e.Id, vId);
      getWorkshopsJourneyVariant(e.Id, id, mId);

      getWorkshopsProductCategory(e.Id, mId);
      setCartStage(3);
    } catch (error) {
      console.log("Error", error);
      alert("something went wrong");
    }
  };

  const handleDiscountPrice = (item) => {
    if (cart.appliedCartOffers) {
      const offer = item.Offers
        ? item.Offers.find((e) => {
            return e?.PromotionId === cart?.appliedCartOffers?.PromotionId;
          })
        : null;
      const filterData = offer ? offer : null;
      if (filterData) {
        const cost = parseFloat(item?.Cost);
        const discountPercentage = cart?.appliedCartOffers
          ?.PromotionPercentValue
          ? parseFloat(cart?.appliedCartOffers?.PromotionPercentValue)
          : 0;
        const d_amount = (cost * discountPercentage) / 100;
        const flatvalue = parseFloat(
          cart?.appliedCartOffers?.PromotionFlatValue
            ? cart?.appliedCartOffers?.PromotionFlatValue
            : 0
        );
        const remainingValue = cost - d_amount - flatvalue;
        return remainingValue ? true : false;
      }
    }
  };

  var settings = {
    dots: false,
    infinite: false,
    speed: 500,
    slidesToShow: 1,
    slidesToScroll: 1,
    initialSlide: 0,
    // arrows: true,
    responsive: [
      {
        breakpoint: 480,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
        },
      },
    ],
    beforeChange: (currentSlide, nextSlide) => {
      setActiveWorkshop(data.workshopFilterMap[nextSlide]);
    },
  };

  useEffect(() => {
    if (
      data.workshopFilterMap != "" &&
      data.workshopFilterMap != undefined &&
      data.workshopFilterMap.length
    ) {
      setActiveWorkshop(data.workshopFilterMap[0]);
    }
  }, []);
  return (
    <div>
      {(activeWorkshop && activeWorkshop?.WorkshopId) ||
      selectedWorkshop.length ? (
        <MapComponent
          coordinatesData={
            selectedWorkshop.length ? selectedWorkshop : [activeWorkshop]
          }
          height={isMobile ? "100vh" : "380px"}
        />
      ) : null}
      <div className="workshop-map-data ">
        <Slider className="mt-2 w-100" {...settings}>
          {data.workshopFilterMap != "" &&
            data.workshopFilterMap != undefined &&
            data.workshopFilterMap.map((item, index) => (
              <div className="workshop-bar border-none">
                <div
                  className="bg-white mx-3"
                  style={{
                    border: "1px solid #ccc",
                    borderRadius: "8px",
                    boxShadow: "0px 0px 3px -1px rgba(0, 0, 0, 0.75)",
                    maxHeight: "192px",
                    padding: "11px",
                  }}
                >
                  <div className="workshop-block-island-list  ">
                    <div className="workshop-block-island-list-t1">
                      <div className="workshop-block-islandlf">
                        <small className="block-islandlf-lgo">
                          <img src={item.LogoUrl} />
                        </small>
                        <div className="garage-ws-lft">
                          <h3>{item.Name}</h3>

                          {isMobile ? (
                            <div
                              className="sm-layerasr"
                              style={{
                                right: "0px  !important",
                                top: "-3px !important",
                              }}
                            >
                              {item?.IsObChoice ? (
                                <small className="glareanimationee">
                                  <img
                                    src="/assets/workshop-detail/choice-icon.svg"
                                    alt="choice-icon"
                                  />
                                  <span>OB CHOICE</span>
                                </small>
                              ) : null}
                            </div>
                          ) : (
                            <div className="sm-layerasr workshop-margin-map">
                              {item?.IsObChoice ? (
                                <small className="glareanimationee">
                                  <img
                                    src="/assets/workshop-detail/choice-icon.svg"
                                    alt="choice-icon"
                                  />
                                  <span>OB CHOICE</span>
                                </small>
                              ) : null}
                              {handleDiscountPrice(item) ? (
                                <label className="offr-labels-island offer_island">
                                  <img src="/assets/products/party-icon.webp" />{" "}
                                  Offers Available
                                </label>
                              ) : null}
                            </div>
                          )}

                          <label>
                            <span>
                              {`${item.AreaName}, `}{" "}
                              {globalData.locationData.data.Emirate ==
                              item.EmirateName
                                ? item.EmirateName
                                : item.EmirateName}
                            </span>
                            <i>
                              {parseFloat(item.Distance).toFixed(2)} KM away
                            </i>
                          </label>
                          <span>
                            <strong>Open</strong>- Closes 7:00 PM
                            {isMobile ? (
                              <div className="rating-wrs-right rating-wrs-mob">
                                <div className="star-rating">
                                  <div className="back-stars">
                                    <WorkshopStars rating={item.GoogleRating} />
                                  </div>
                                </div>
                                <span>({item.GoogleRating})</span>
                              </div>
                            ) : (
                              <span></span>
                            )}
                          </span>

                          {isMobile ? (
                            <div className="sm-layerasr smly-mob">
                              {/* {item?.IsObChoice ? (
                                <small className="glareanimationee">
                                  <img
                                    src="/assets/workshop-detail/choice-icon.svg"
                                    alt="choice-icon"
                                  />
                                  <span>OB CHOICE</span>
                                </small>
                              ) : null} */}
                              {handleDiscountPrice(item) ? (
                                <label className="offr-labels-island offer_island">
                                  <img src="/assets/products/party-icon.webp" />{" "}
                                  Offers Applied
                                </label>
                              ) : null}
                            </div>
                          ) : (
                            <span></span>
                          )}
                        </div>
                      </div>
                      {isMobile ? (
                        <span></span>
                      ) : (
                        <div className="rating-wrs-right">
                          <div className="star-rating">
                            <div className="back-stars">
                              <WorkshopStars rating={item.GoogleRating} />
                            </div>
                          </div>
                          <span>({item.GoogleRating})</span>
                        </div>
                      )}
                    </div>
                  </div>
                  <div className="amenities-list-sdbar">
                    <ul>
                      {item.Amenities && item.Amenities?.length
                        ? item.Amenities?.slice(0, 3).map((item, index) => {
                            return (
                              <li>
                                <span className="d-flex">
                                  <img src={item.ImgUrl} />
                                  <i>{item.Name}</i>
                                </span>
                              </li>
                            );
                          })
                        : null}

                      {item.Amenities.length > 3 ? (
                        <li
                          className="more-item-amenties"
                          onClick={() => {
                            setShowPopup(!showpopup);
                          }}
                        >
                          <label>+3</label>
                          {showpopup ? (
                            <div
                              ref={PopupRef}
                              className="workshop-block-island-ul drp-list-amn"
                              style={{ width: "150px", zIndex: 999 }}
                            >
                              <ul
                                style={{
                                  flexDirection: "column",
                                  alignItems: "flex-start",
                                }}
                              >
                                {item.Amenities.slice(3).map((item, index) => {
                                  return (
                                    <li className="p-1">
                                      <span className="d-flex">
                                        <img src={item.ImgUrl} />
                                        <i>{item.Name}</i>
                                      </span>
                                    </li>
                                  );
                                })}
                              </ul>
                            </div>
                          ) : (
                            ""
                          )}
                        </li>
                      ) : null}
                    </ul>
                  </div>
                  <div
                    className="action-bard-island-wrk"
                    style={{ marginBottom: isMobile ? "-7px" : "-3px" }}
                  >
                    <label className="d-flex align-items-center">
                      <img
                        src="/assets/workshop-detail/90days.svg"
                        className="labor-icon-webshow"
                      />
                      <span>90 Days Labor Warranty</span>
                    </label>
                    <div className="d-flex">
                      {parseFloat(item.Cost) >
                      parseFloat(
                        JSON.parse(localStorage.getItem("product-amount"))
                      ) ? (
                        <span className="d-flex align-items-center workshop-price-difference mx-2">{`+ AED ${parseFloat(
                          parseFloat(item.Cost) -
                            parseFloat(
                              JSON.parse(localStorage.getItem("product-amount"))
                            )
                        ).toFixed(2)} Higher Price`}</span>
                      ) : (
                        <span className="d-flex align-items-center workshop-price-difference-low mx-2">
                          AED {parseFloat(item.Cost).toFixed(2)}
                        </span>
                      )}
                      {item.Id === cart.workshop?.Id ? (
                        <button
                          className="workshop-button-one workshop-select-btn bg-yellow"
                          style={{ fontSize: 12, padding: "12px 26px" }}
                        >
                          Selected
                        </button>
                      ) : (
                        <button
                          onClick={() => selectWorkshop(item)}
                          className={
                            "workshop-button-one workshop-select-btn workshop-" +
                            index
                          }
                          style={{ fontSize: 12 }}
                          // disabled={isSubmitting == item.Id}
                        >
                          Select{" "}
                          {isSubmitting ? (
                            <Spinner
                              animation="grow"
                              role="status"
                              className="ml-2"
                              size="sm"
                            >
                              <span className="visually-hidden"></span>
                            </Spinner>
                          ) : null}
                        </button>
                      )}
                    </div>
                  </div>
                </div>
              </div>
            ))}
        </Slider>
      </div>
    </div>
  );
};

const mapStateToProps = (state) => {
  return {
    cart: state.cart,
    apiData: state.apiData,
    globalData: state.globalData,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    getWorkshopsAddonByVariant: (id, vId) => {
      dispatch(getWorkshopsAddonByVariant(id, vId));
    },
    getWorkshopsJourneyVariant: (id, cId, mId) => {
      dispatch(getWorkshopsJourneyVariant(id, cId, mId));
    },
    getWorkshopsProductCategory: (id, mId) => {
      dispatch(getWorkshopsProductCategory(id, mId));
    },
    setCartStage: (stage) => {
      dispatch(setCartStage(stage));
    },
    setCartWorkshop: (data) => {
      dispatch(setCartWorkshop(data));
    },
    setCartJobItems: (data) => {
      dispatch(setCartJobItems(data));
    },
    addToCart: (workshopId, variant, carModeId) => {
      dispatch(addToCart(workshopId, variant, carModeId));
    },
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(Map);
